import { AssertionError } from "../domain/error/assertion-error.ts";
import { alertDevs } from "../observability/alert-devs.ts";

export function assertThat(check: boolean, message: string, context?: Record<string, unknown>): asserts check {
  if (check) {
    return;
  }

  const error = new AssertionError(message, context);

  alertDevs({
    message: `[Assertion Error] ${error.message}`,
    exception: error,
    context,
  });

  throw error;
}
